import { render, staticRenderFns } from "./TeacherCard.vue?vue&type=template&id=f560ceea&"
import script from "./TeacherCard.vue?vue&type=script&lang=js&"
export * from "./TeacherCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports